// extracted by mini-css-extract-plugin
export default {"container":"NewTreatmentModal_container__Ui2tu","content":"NewTreatmentModal_content__Yvebh","buttons":"NewTreatmentModal_buttons__yRIUv"};